<template>
  <v-layout>
      <span>
        <v-icon class="pr-3">{{icon}}</v-icon>
        {{alert.name}}
      </span>
  </v-layout>
</template>

<script>
  export default {
    name: 'alert-header',
    props: ['alert'],
    computed: {
      icon () {
        return this.alert.isActive ? 'notifications' : 'notifications_off'
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertHeader.vue